<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.type === 'create' ? $t('scope.text_539') : $t('scope.text_634') }}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_692')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.recipient" :placeholder="$t('scope.text_693')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_694')" v-bind="formItemLayout">
          <a-cascader
            v-decorator="decorators.residence"
            :options="options"
            :load-data="loadData"
            :fieldNames="fieldNames"
            :placeholder="$t('scope.text_593')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_695')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.address" :placeholder="$t('scope.text_696')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_494')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.phone" :placeholder="$t('scope.text_697')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_698')" v-bind="formItemLayout">
          <a-switch checked-:children="$t('scope.text_699')" un-checked-:children="$t('scope.text_700')" v-decorator="decorators.is_default" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import jsonp from '@/utils/jsonp'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'AddInvoiceAddressDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      decorators: {
        recipient: [
          'recipient',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].recipient : '',
            rules: [
              { required: true, message: this.$t('scope.text_693') },
            ],
          },
        ],
        residence: [
          'residence',
          {
            initialValue: this.params.type === 'edit' ? [this.params.data[0].province, this.params.data[0].city, this.params.data[0].district, this.params.data[0].street] : [],
            rules: [
              { type: 'array', required: true, message: this.$t('scope.text_701') },
            ],
          },
        ],
        address: [
          'address',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].address : '',
            rules: [
              { required: true, message: this.$t('scope.text_696') },
            ],
          },
        ],
        phone: [
          'phone',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].phone : '',
            rules: [
              { required: true, message: this.$t('scope.text_697') },
            ],
          },
        ],
        is_default: [
          'is_default',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].is_default : false,
            valuePropName: 'checked',
          },
        ],
      },
      options: [],
      fieldNames: {
        label: 'fullname',
        value: 'fullname',
        children: 'children',
      },
      whiteList: [
        this.$t('scope.text_702'),
        this.$t('scope.text_703'),
        this.$t('scope.text_704'),
        this.$t('scope.text_705'),
        this.$t('scope.text_706'),
        this.$t('scope.text_707'),
      ],
    }
  },
  created () {
    this.fetchProvince()
  },
  methods: {
    async loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      try {
        const result = await this.getChildren(targetOption)
        targetOption.loading = false
        // 直辖市二级结构填充
        if (this.whiteList.indexOf(targetOption.fullname) > -1 && selectedOptions.length < 2) {
          const obj = {
            fullname: targetOption.fullname,
            id: targetOption.id,
            location: targetOption.location,
            name: targetOption.name,
            pinyin: targetOption.pinyin,
          }
          targetOption.children = [obj]
        } else {
          targetOption.children = result[0]
        }
        if (selectedOptions.length < 3) {
          targetOption.children.forEach(item => { item.isLeaf = false })
        }
        this.options = [...this.options]
        return targetOption
      } catch (error) {
        targetOption.loading = false
        throw error
      }
    },
    fetchProvince () {
      jsonp('https://apis.map.qq.com/ws/district/v1/list?key=F6QBZ-TCK6X-Q7K47-736QZ-IM7VE-XNFRU&output=jsonp', {
        name: 'function1',
      }, async (err, data) => {
        if (err) throw err
        const result = data.result
        this.options = result[0]
        this.options.forEach(item => { item.isLeaf = false })
        if (this.params.data.length > 0) {
          const { province, city, district } = this.params.data[0]
          const initProvinceOption = this.options.filter(item => { return item.fullname === province })
          const cityOptions = await this.loadData(initProvinceOption, true)
          const initCityOption = cityOptions.children.filter(item => { return item.fullname === city })
          initCityOption.unshift(cityOptions)
          const districtOptions = await this.loadData(initCityOption, true)
          const initDistrictOption = districtOptions.children.filter(item => { return item.fullname === district })
          this.loadData(initDistrictOption, true)
        }
      })
    },
    doCreate (data) {
      return this.params.onManager('create', {
        managerArgs: {
          data,
        },
      })
    },
    doEdit (data) {
      return this.params.onManager('update', {
        id: this.params.data[0].id,
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        const data = {
          ...values,
          country: this.$t('scope.text_601'),
          name: 'commonlyused',
        }
        data.province = values.residence[0]
        data.city = values.residence[1]
        data.district = values.residence[2]
        data.street = values.residence[3]
        delete data.residence
        if (this.params.type === 'create') {
          await this.doCreate(data)
        } else {
          await this.doEdit(data)
        }
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
    getChildren (targetOption) {
      return new Promise((resolve, reject) => {
        jsonp(`https://apis.map.qq.com/ws/district/v1/getchildren?key=F6QBZ-TCK6X-Q7K47-736QZ-IM7VE-XNFRU&output=jsonp&id=${targetOption.id}`, {
          name: 'function1',
        }, (err, data) => {
          if (err) return reject(new Error(err))
          return resolve(data.result)
        })
      })
    },
  },
}
</script>
